/**
 * Fullscreen modal directive
 * usage example: <modal data="modal" template="templates/popup.html" back="app.assets" count="5"></modal>
 * data:
 *  state: true/false - show modal/hide modal
 *  back: state name to which redirect after popup close (use this parameter or 'back' parameter)
 *  params: object for state to redirect
 *  count: number of seconds to close the popup
 */
app.directive('modal', ['$state', '$ionicHistory', '$ionicModal', '$timeout', '$interval', 'LocaleService', 'LocalStorage', 'constants',
    function ($state, $ionicHistory, $ionicModal, $timeout, $interval, LocaleService, LocalStorage, Const) {
        return {
            scope: {
                data: '<',
                template: "@",
                back: "<",
                close: "@"
            },
            link: function (scope, element) {

                var defaultTemplate = "templates/directives/popup.html",
                    timeout,
                    backCounterTimeout;

                LocaleService.wait().then(function (translation) {
                    scope.translation = translation;
                });

                scope.backCounter = scope.close;
                scope.constants = Const;

                // Only for webtraders brands like - IronFX, FxGiangs, T4Trade
                scope.openClientPortal = function() {
                    scope.data.state = false;
                    scope.modal.hide();
                    $ionicHistory.clearHistory();
                    var url = scope.constants.clientPortalUrl.replace(/\%lang\%/, LocalStorage.get('language'));
                    window.open(url, '_blank');
                }

                //modal hide flow
                scope.hide = function (back) {
                    //cancel timeout
                    $timeout.cancel(timeout);

                    //set parent controller's state to false
                    scope.data.state = false;

                    //hide modal
                    scope.modal.hide();
                    $ionicHistory.clearHistory();
                    //redirect to view
                    return navigate(back);
                };

                function navigate(backData) {
                    var back = backData || scope.data.back || scope.back;
                    if (!back) return;

                    if (typeof back === 'object') {
                        back.clearHistory && $ionicHistory.clearHistory();
                        return $state.go(back.state, back.params)
                    }
                    if (typeof back === 'function') {
                        return back();
                    }
                    $ionicHistory.clearHistory();
                    return $state.go(back);
                }

                //set $modal object into our local scope
                function setModal(modal) {
                    scope.modal = modal;
                }

                //create modal
                $ionicModal.fromTemplateUrl(scope.template || defaultTemplate, {
                    scope: scope,
                    hardwareBackButtonClose: false,
                    animation: 'slide-in-up'
                }).then(setModal);

                //watch for parent state change
                var stateWatch = scope.$watch('data.state', function (newVal, oldVal) {

                    //modal show
                    if (newVal !== oldVal && newVal) {
                        scope.modal.show();
                    }

                    //modal hide
                    if (newVal !== oldVal && !newVal) {
                        scope.hide();
                    }
                });

                element.on('$destroy', function () {
                    $ionicHistory && $ionicHistory.clearHistory();
                    stateWatch();
                    scope.data = null;
                    scope.modal && scope.modal.remove();
                    scope.modal = null;
                });

            }
        }


    }]);
